import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import AppWrapper from 'components/app';
import SearchResults from 'components/searchResults';
import OrderTracking from 'components/orderTracking';
import TipAndRate from 'components/TipAndRate';
import Account from 'components/account';
import Loyalty from 'components/loyalty';
import ContactPreferences from 'components/contactPreferences';
import OrderHistory from 'components/orderHistory';
import OrderHistoryOrder from 'components/orderHistory/order';
import SharePage from 'components/sharePage';
import Brands from 'components/brands';
import BrandPage from 'components/brands/brand';
import CheckoutPage from 'components/checkoutPage';
import LoginPage from 'components/authPages/login';
//import AccountLinkPage from 'components/authPages/accountLink';
import AccountLinkModal from 'components/authPages/accountLinkFlow/accountContainer';
import ForgotPasswordPage from 'components/authPages/forgot';
import SignupPage from 'components/authPages/signup';
import SubstitutionsPage from 'components/substitutions';
import GiftClaimPage from 'components/GiftClaim';
import Home from 'components/home';
import Storefront from 'components/storefront';
import Gifting from 'components/gifting';
import CategoryGroup from 'components/categoryGroup';
import Category from 'components/category';
import Product from 'components/product';
import NotFoundPage from 'components/errorPages/NotFound';
import withErrorBoundary from 'components/errorPages/withErrorBoundary';
import ContactUs from 'components/staticPages/ContactUs';
import LoyaltyProgramBenefits from 'components/staticPages/LoyaltyProgramBenefits';
import MerchantTermsOfService from 'components/staticPages/MerchantTermsOfService';
import PrivacyPolicy from 'components/staticPages/PrivacyPolicy';
import TermsOfService from 'components/staticPages/TermsOfService';
import ReturnsAndRefunds from 'components/staticPages/ReturnsAndRefunds';
// import BecomeACourier from 'components/BecomeACourier';
import CityPage from 'components/CityPage';
import BecomeARetailer from 'components/BecomeARetailer';
import CorporateAccounts from 'components/CorporateAccounts';
import Careers from 'components/Careers';
import AccountLinked from './components/authPages/accountLinkFlow';

const Routes = () => (
  <Switch>
    <Route
      exact
      path="/login"
      component={withErrorBoundary(LoginPage, AppWrapper)}
    />
    <Route
      exact
      path="/account-link"
      component={withErrorBoundary(AccountLinkModal, AppWrapper)}
    />
    <Route
      exact
      path="/forgot-password"
      component={withErrorBoundary(ForgotPasswordPage, AppWrapper)}
    />
    <Route
      exact
      path="/signup"
      component={withErrorBoundary(SignupPage, AppWrapper)}
    />
    <Route
      exact
      path="/signup/:promo"
      component={withErrorBoundary(SignupPage, AppWrapper)}
    />
    <Route
      exact
      path="/checkout"
      component={withErrorBoundary(CheckoutPage, AppWrapper)}
    />
    <Route
      exact
      path="/substitution/:orderId*"
      component={withErrorBoundary(SubstitutionsPage, AppWrapper)}
    />
    <Route
      path="/giftclaim/:orderId"
      component={withErrorBoundary(GiftClaimPage, AppWrapper)}
    />
    <Route exact path="/" component={withErrorBoundary(Home, AppWrapper)} />
    <Route
      exact
      path="/alcohol-delivery-:slug"
      component={withErrorBoundary(CityPage, AppWrapper)}
    />
    <Route
      exact
      path="/tracking"
      component={withErrorBoundary(OrderTracking, AppWrapper)}
    />
    <Route
      exact
      path="/tracking/:order_id"
      component={withErrorBoundary(OrderTracking, AppWrapper)}
    />
    <Route
      exact
      path="/tip/:id"
      component={withErrorBoundary(TipAndRate, AppWrapper)}
    />

    <Route>
      <AppWrapper>
        <Switch>
          <Route
            exact
            path="/welcome"
            component={withErrorBoundary(Storefront)}
          />
          <Route exact path="/gifting" component={withErrorBoundary(Gifting)} />
          <Route exact path="/account" component={withErrorBoundary(Account)} />
          <Route exact path="/loyalty" component={withErrorBoundary(Loyalty)} />
          <Route
            exact
            path="/contact-preferences"
            component={withErrorBoundary(ContactPreferences)}
          />
          <Route
            exact
            path="/orders"
            component={withErrorBoundary(OrderHistory)}
          />
          <Route exact path="/privacy-policy" component={PrivacyPolicy} />
          <Route exact path="/terms-of-service" component={TermsOfService} />
          <Route exact path="/returns-refunds" component={ReturnsAndRefunds} />
          <Route exact path="/contact-us" component={ContactUs} />
          <Route
            exact
            path="/merchant-terms"
            component={MerchantTermsOfService}
          />
          <Route
            exact
            path="/loyalty-program-benefits"
            component={LoyaltyProgramBenefits}
          />
          <Route exact path="/emjay-redirect" component={AccountLinked} />
          <Redirect from="/join" to="/apply" />
          <Redirect from="/jobs" to="/careers" />
          <Route exact path="/careers" component={Careers} />
          <Route exact path="/retailers" component={BecomeARetailer} />
          <Route exact path="/business" component={CorporateAccounts} />
          <Route
            exact
            path="/orders/:id"
            component={withErrorBoundary(OrderHistoryOrder)}
          />
          <Route exact path="/share" component={withErrorBoundary(SharePage)} />
          <Route exact path="/brands" component={withErrorBoundary(Brands)} />
          <Route
            exact
            path="/brands/:brandname"
            component={withErrorBoundary(BrandPage)}
          />
          <Route
            exact
            path="/wine"
            component={withErrorBoundary(CategoryGroup)}
          />
          <Route
            exact
            path="/spirits"
            component={withErrorBoundary(CategoryGroup)}
          />
          <Route
            exact
            path="/more"
            component={withErrorBoundary(CategoryGroup)}
          />
          <Route
            exact
            path="/search/:searchQuery"
            component={withErrorBoundary(SearchResults)}
          />
          <Route
            exact
            path="/**/:sku([A-Za-z]{2,3}-[A-Za-z0-9]{1,}-[A-Za-z0-9]{1,})"
            component={withErrorBoundary(Product)}
          />
          <Route
            exact
            path="/:category/:name"
            component={withErrorBoundary(CategoryGroup)}
          />
          <Route
            exact
            path="/:category"
            component={withErrorBoundary(Category)}
          />
          <Route component={NotFoundPage} />
        </Switch>
      </AppWrapper>
    </Route>
  </Switch>
);

export default Routes;
